export default "__VITE_ASSET__Bu6LJ5_t__"